<template>
  <div class="payroll__submit">
    <div class="payroll__submit--message">
      <span>You Did It, {{ userName }}!</span>
      <p>
        Time to kick back. hrdesk will debit
        <span>₦{{ debitedAmount }}</span> from your company's account on
        <span>{{ month }} {{ date }}, {{ year }}</span
        >. Make sure you have these funds available.
      </p>
      <div>
        <div>
          <span>Employee Pay Date</span>
          <p>{{ month }} {{ date }}, {{ year }}</p>
        </div>
        <div>
          <span>Total Employee Take Home</span>
          <p>₦{{ compensationTotal }}</p>
        </div>
        <div>
          <span>Transaction Cost</span>
          <p>₦{{ transactionCost }}</p>
        </div>
      </div>
    </div>
    <div class="payroll__submit--error">
      <span v-if="cancelMessage">{{ cancelMessage }}</span>
      <span v-if="payNowMsg">{{ payNowMsg }}</span>
      <span v-if="networkError">An error occurred. Please try again.</span>

      <div v-for="(error, index) in formErrors" :key="index">
        <small style="color: red">{{ error }}</small>
      </div>
    </div>
    <div class="payroll__submit--btn">
      <div
        class="payroll__submit--btn-pay"
        @click="payNow"
        v-if="!payNowLoader"
      >
        <font-awesome-icon icon="check-circle" />&nbsp;Pay Now
      </div>
      <div class="payroll__submit--btn-pay" v-if="payNowLoader">
        <WhiteLoader />
      </div>
      <div
        class="payroll__submit--btn-cancel"
        @click="cancelPayment"
        v-if="!cancelLoader"
      >
        <font-awesome-icon icon="times-circle" />&nbsp;Cancel Payroll
      </div>
      <div class="payroll__submit--btn-cancel" v-if="cancelLoader">
        <BlueLoader />
      </div>
    </div>
    <div class="payroll__submit--image">
      <img src="./../../../assets/images/beach.png" alt />
    </div>
  </div>
</template>

<script>
import WhiteLoader from "../../partials/white-loader";
import BlueLoader from "../../partials/blue-loader";
import * as types from "../../../store/constant";

export default {
  name: "PayrollConfirm",
  components: {
    WhiteLoader,
    BlueLoader,
  },
  data() {
    return {
      home: true,
      userName: "",
      debited: false,
      pays: false,
      date: null,
      month: null,
      year: null,
      debitedAmount: 0,
      compensationTotal: 0,
      transactionCost: 0,
      payrollId: null,
      payNowLoader: false,
      cancelLoader: false,
      payNowMsg: null,
      networkError: false,
      cancelMessage: null,
      formErrors: [],
    };
  },
  methods: {
    displayPayroll(payrollId) {
      this.payrollId = payrollId;

      this.$http.get(`${types.GET_PAYROLL}/${payrollId}`).then((resp) => {
        let data = resp.data.data;
        this.compensationTotal = data.total_amount - data.total_fees;
        this.transactionCost = 0;

        let totalFees = parseFloat(data.total_fees);

        let totalAmount = parseFloat(data.total_amount);

        let debitAmount = totalAmount;

        this.debitedAmount = debitAmount
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        this.transactionCost = totalFees
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        this.date = data.day;
        // this.month = "May";
        this.year = data.year;
        this.month = this.sortMonth(data.month);
      });
    },
    sortMonth(month) {
      switch (month) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
        default:
          return "Invalid month";
      }
    },
    openHomeTable() {
      this.home = true;
      this.debited = false;
      this.pays = false;
    },
    openDebitedTable() {
      this.home = false;
      this.debited = true;
      this.pays = false;
    },
    openPaysTable() {
      this.home = false;
      this.debited = false;
      this.pays = true;
    },
    gotoTop() {
      window.scrollTo(0, 0);
    },
    payNow() {
      this.payNowLoader = true;
      this.payNowMsg = null;
      this.formErrors = [];
      this.$http
        .post(types.PAYOUT_PAYNOW, {
          payroll_uuid: this.payrollId,
        })
        .then((resp) => {
          this.payNowLoader = false;
          this.$emit("clickedSuccess");
        })
        .catch((error) => {
          this.payNowLoader = false;

          if (error.response.status === 422) {
            let errors = error.response.data.message;

            for (const key in errors) {
              if (errors.hasOwnProperty(key)) {
                const errorArray = errors[key];
                if (errorArray.length > 0) {
                  this.formErrors.push(errorArray[0]);
                }
              }
            }
          }

          if (error.response.status === 400) {
            this.payNowMsg = error.response.data.message;
          }
        });
    },
    cancelPayment() {
      this.cancelLoader = true;
      this.networkError = false;
      this.cancelMessage = null;
      this.$http
        .delete(types.PAYOUT_CANCEL, {
          data: {
            payroll_uuid: this.payrollId,
          },
        })
        .then(() => {
          this.cancelLoader = false;
          this.$router.push("/payroll/regular/initiate");
        })
        .catch((err) => {
          this.cancelMessage = err.response.data.message;
          this.cancelLoader = false;
        });
    },
  },
  mounted() {
    this.gotoTop();
    this.date = this.$store.state.payrollDate;
    this.month = this.$store.state.payrollMonth;
    this.year = this.$store.state.payrollYear;
  },
  created() {
    this.$emit("emitShowGoBack");

    let user = this.$store.getters.currentAuthUser;

    this.userName = user.firstname;

    let payrollId = this.$router.currentRoute.query.payroll_id;

    if (payrollId !== undefined) {
      this.displayPayroll(payrollId);
    } else {
      if (Object.keys(this.$store.state.summaryData).length === 0) {
        this.$router.push("/payroll");
        return;
      }

      let summaryData = this.$store.state.summaryData;

      this.compensationTotal = summaryData.totalNetAmount
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

      this.transactionCost = summaryData.totalCost
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

      this.debitedAmount = summaryData.totalNetPlusTotalCost
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      this.date = summaryData.day;
      this.year = summaryData.year;
      this.month = this.sortMonth(summaryData.month);
      this.payrollId = summaryData.payroll_id;
    }
  },
};
</script>

<style lang="scss" scoped>
.payroll__submit {
  margin-top: 20px;
  padding-bottom: 200px;
  padding-top: 20px;
  padding-left: 9.427vw;
  padding-right: 9.427vw;

  > .payroll__submit--message {
    overflow: hidden;
    padding: 20px 0 0 0;
    text-align: center;

    > span {
      font-size: 2.083vw;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 0.75;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
    }

    > p {
      font-size: 1.25vw;
      font-weight: 200;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: normal;
      text-align: center;
      color: #000000;
      max-width: 800px;
      margin: 20px auto 0 auto;

      > span {
        font-weight: normal;
        color: #5099de;
      }
    }

    > div {
      max-width: 700px;
      margin: 30px auto 10px auto;
      overflow: hidden;

      > div {
        width: 33.33333333%;
        float: left;

        > span {
          font-size: 1.25vw;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
        }

        > p {
          font-size: 1.25vw;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          font-weight: 200;
        }
      }
    }
  }

  > .payroll__submit--error {
    color: red;
    text-align: center;
    font-style: italic;
    margin-bottom: 10px;
    font-size: 12px;
  }

  > .payroll__submit--btn {
    width: 300px;
    margin: 0 auto 20px auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    align-content: center;

    > .payroll__submit--btn-pay {
      width: 45%;
      height: 40px;
      min-width: 100px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #5099de;
      border: 1px solid #5099de;
      font-size: 13px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      cursor: pointer;
    }

    > .payroll__submit--btn-cancel {
      width: 45%;
      height: 40px;
      min-width: 100px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border: 1px solid #5099de;
      font-size: 13px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #000;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      cursor: pointer;
    }
  }

  > .payroll__submit--image {
    width: 46.198vw;
    margin: 0 auto;
  }

  > .payroll__submit--links {
    margin-top: 120px;

    > div {
      text-align: left;

      span {
        font-size: 1.25vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        cursor: pointer;
        color: #5099de;
      }

      > p {
        font-size: 1.25vw;
        font-weight: 200;
        max-width: 800px;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.46;
        letter-spacing: normal;
        color: #000000;
      }
    }
  }
}
</style>
